/**
 * If, pure half.
 *
 * Moved verbatim from components/FlowBuilder/flow-components/components/IfComponent.js. Runs unchanged in the
 * browser and, via the flow-core bundle, inside GraalJS on the backend, so it
 * must never reach for React, the DOM, Node APIs, or the network.
 */

import { conditionToVisibleExpression, conditionToIfExpression, parseSimpleExpression } from '../conditionUtils';
import { toBuilderChild, toWhatsAppChild } from '../containerChildren';

export const IfCore = {
  type: 'If',
  name: 'If Block',
  icon: '⚡',
  description: 'Layout block that shows its contents only when a condition is true.',
  category: 'layout',
  maxPerScreen: null,
  getDefaultProperties() {
    return {
      _ifCondition: { mode: 'simple', field: '', operator: 'eq', value: '', expression: '' },
      then: [],
      else: [],
    };
  },
  validateProperties(properties) {
    const errors = [];
    const warnings = [];
    if (!conditionToVisibleExpression(properties._ifCondition)) {
      errors.push('Condition is required');
    }
    if (!properties.then?.length) {
      warnings.push('Then branch has no components');
    }
    return { errors, warnings };
  },
  transformToWhatsApp(properties) {
    const condition = conditionToIfExpression(properties._ifCondition) || 'true';
    const serializeSubs = (subs) => (subs || []).map(toWhatsAppChild);

    const result = {
      type: 'If',
      condition,
      then: serializeSubs(properties.then),
    };
    const elseItems = serializeSubs(properties.else);
    if (elseItems.length > 0) result.else = elseItems;
    return result;
  },
  transformFromWhatsApp(wa) {
    const rawCondition = wa.condition || '';
    const inner = rawCondition.replace(/^`|`$/g, '');
    return {
      _ifCondition: parseSimpleExpression(inner) || { mode: 'power', expression: inner },
      then: (wa.then || []).map(toBuilderChild),
      else: (wa.else || []).map(toBuilderChild),
    };
  },
};
